<template>
  <div class="ProfessionalsPrivacyPolicy">
    <el-button @click="backToLogin" type="primary" icon="el-icon-arrow-left">Back</el-button>
    <pre>
      
      Privacy Policy for For Professionals
      LEAPIN GROUP PTE. LTD.
      Introduction
      This privacy policy explains how LEAPIN GROUP PTE. LTD. ("we," "us," or "our company") collects, uses, protects, and shares the personal information of Job Coaches ("users" or "you"). We are committed to safeguarding your privacy and ensuring the security of your data.
      Information We Collect
      We may collect the following types of personally identifiable information:
      Name, email address, phone number, professional qualifications, and experience;
      Information you provide while using our services, such as your coaching preferences and professional background;
      Technical data such as your IP address, browser type, and operating system.
      How We Use Your Information
      We use the information collected for these purposes:
      1.To create and manage your account;
      2.To send administrative notifications, including updates to terms and policies;
      3.To improve and optimize our services and operations;
      4.To analyze how you use our platform and enhance its functionality;
      5.To communicate with you about customer service, platform updates, promotions, and marketing;
      6.To detect and prevent fraudulent transactions and other unlawful activities;
      7.To match you with Job Seekers based on your professional expertise and experience.
      Information Disclosure
      Your information may be disclosed in the following circumstances:
      1.Legal Requirements and Protection: When required by law or to protect our rights, property, and safety.
      2.Business Transfers: During mergers, sales, financing, or acquisitions, your information may be shared or transferred.
      3.Third-Party Service Providers: We may share your information with vendors providing services like data analytics, email delivery, hosting, customer service, and marketing.
      Data Security
      We implement administrative, technical, and physical measures to safeguard your personal information. However, no method of transmission over the internet or method of electronic storage is completely secure.
      Rights of Users
      You have the following rights regarding your personal data:
      1.Access your personal information;
      2.Request corrections or deletion of your data;
      3.Understand how your data is used;
      4.Withdraw your consent for data processing.
      Cross-Border Data Transfers
      We will not transfer your personal data outside of Singapore unless the recipient ensures protections equivalent to Singapore’s Personal Data Protection Act (PDPA).
      Data Retention Period
      We will retain your personal data for as long as you are actively using our services as a Job Coach, and for a reasonable period after your activity ends. Expired information will be securely deleted or destroyed.
      Updates to This Policy
      This privacy policy may be updated from time to time. We encourage you to regularly review this policy for changes.
      Contact Us
      If you have any questions about this privacy policy or need further information, please contact us at:
      15 BEACH ROAD, #05-08, BEACH CENTRE, SINGAPORE (189677)
    </pre>
    
  </div>
</template>

<script>
export default {
  name: 'ProfessionalsPrivacyPolicy',
  data() {
    return {

    }
  },
  mounted () {

  },
  methods: {
    backToLogin() {
      window.history.back();
    }
  }
}
</script>
<style lang="scss" scoped>
.ProfessionalsPrivacyPolicy {
  margin: 32px 0 0 32px;
  pre {
    white-space: pre-wrap;
    font-size: 15px;
  }
}
</style>